const config = __APP_CONFIG__;

module.exports = config;